import type { FaireProductEntity } from "../../entity_types/product";

export const p_f4dj444q7z: FaireProductEntity = {
  token: "p_f4dj444q7z",
  type: "product",
  name: "*NEW* Every Phase™ Hormone Balancing Herbal Drops",
  brandToken: "b_2jo44vh8jq",
  brandName: "Apothékary",
  imageUrl:
    "https://cdn.faire.com/fastly/e63e147f8b1609f90c4ae0fa7af268389be2d98d602f7814908f5bb8b3e5ea4a.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9de9b5078b6eb65371cc5e6b08184be2e0e9cf64e4b42355bc50d2a0eb25c3c3.png",
    "https://cdn.faire.com/fastly/51f5e4adf8c5aeb864127531226cfbcd741dfc12e2248822fcc199c16d1a9b3e.jpeg",
    "https://cdn.faire.com/fastly/367598e9a927e2d027630faccac028fb0234d1ef5cf307b28dbe1619f261987c.jpeg",
    "https://cdn.faire.com/fastly/c943418e04c57effde7ccb1ab8e0624ba8b109ebedbf1d4eb01794030121aed2.jpeg",
    "https://cdn.faire.com/fastly/dfa4c415b84af616b795b70387b68f4c31b6110abf958baa9c06bfcd83d5ed28.jpeg",
    "https://cdn.faire.com/fastly/4d04dae4c2e5f6de6969ca3d05387ea7dfc6d55e6fd67600473aeb452de4a1ff.jpeg",
    "https://cdn.faire.com/fastly/dc31905baba8b77ba4bebf1047ca89e6ba308a22dded916cb655e470da0bdaa1.jpeg",
    "https://cdn.faire.com/fastly/3729aa9aac8b757944d2898add2aa5b8ae1d62b59f7f1d8a35459353e22abca6.jpeg",
    "https://cdn.faire.com/fastly/3d730cc4b4ec7f2f1312063bfbd48ee3987263c593183e8bea5bb26250a2cb0c.jpeg",
    "https://cdn.faire.com/fastly/a3694544baba3e9ff0b4af81e4278c6847f9efaebbe1e3f0fa638e0cccdee879.jpeg",
    "https://cdn.faire.com/fastly/0db3d858eb3915c60780135edff7d44cc92876a025faeac3e75389b7db76cb0b.jpeg",
  ],
  priceDollars: 27,
  description:
    "Every Phase™ is a NEW daily hormone-balancing tincture that supports mood, sleep, and cycle comfort through PMS, perimenopause, and menopause. Made with Pycnogenol®, it helps you feel like yourself without the hormone fluctuations —through every phase.*\n\n1 fl oz. (30mL)\n\nIngredients:\n\nLemon Balm Leaf\nShatavari Root\nChaste Tree Berry\nCeylon Cinnamon Bark\nPycnogenol (French Maritime Pine Bark)\nVegetable Glycerin\nPurified Water\nMandarin Juice Concentrate\nSunflower Lechithin\nYuzu Juice Powder\nGinger Juice Powder",
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:34.615Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
